export const setLastVisitPath = (fullPath: string) => {
  localStorage.setItem("lastVisitedPath", fullPath);
};
export const getLastVisitPath = () => {
  return localStorage.getItem("lastVisitedPath") || "/";
};

export const getLastVisitStep = () => {
  const path = localStorage.getItem("lastVisitedPath") || "/";

  // Extract step from query parameters
  const url = new URL(path, window.location.origin);
  const step = url.searchParams.get("step");

  return step || null;
};
